import { Container, Grid } from "@mui/material";
import React from "react";
import { HashLink } from "react-router-hash-link";
import "../css/newProduct.css";

const NewProduct = () => {
  const featuredImage = "/assets/Dec-Tec Terrazzo.jpg";

  return (
    <div>
      <Container maxWidth="lg">
        <div className="container">
          <Grid container spacing={5} columnSpacing={{ xs: 5, sm: 5, md: 3 }}>
            <Grid
              size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
              sx={{ alignItems: "center", display: "flex" }}
            >
              <div className="elementor-wrap-div">
                <div className="elementor-row elementor-m-col">
                  <h3 className="heading-title">
                    <span className="title-bold">NEW</span>
                  </h3>
                  <h3 className="heading-title">
                    <span className="text-with-border">PRODUCT</span>
                  </h3>
                </div>
                <div className="divider-without-underline"></div>
                <h4>
                  <strong className="str">
                    We've Added a Stunning New Design to Our Most Popular
                    Classic Modern Collection
                  </strong>
                </h4>
                <div className="paragraph">
                  <p>
                    <strong>Introducing: TERRAZZO</strong>
                  </p>
                  <p>
                    Inspired by contemporary architecture and engineered for
                    lasting performance, Terrazzo brings a bold new aesthetic to
                    our most popular Classic Modern collection.
                  </p>
                  <p>
                    Crafted from the same premium walkable PVC membrane trusted
                    by contractors and homeowners alike, Terrazzo delivers the
                    proven waterproof protection, durability, slip resistance,
                    and low-maintenance performance you've come to expect from
                    our Classic Line—now with a sophisticated terrazzo-inspired
                    finish designed to elevate any outdoor living space.
                  </p>
                  <p>
                    Modern design. Proven performance. The perfect combination
                    of style and durability.
                  </p>
                </div>
                <div className="elementor-button">
                  <HashLink 
                    smooth 
                    scroll={el => {
                      const y = el.getBoundingClientRect().top + window.scrollY - 100;
                      window.scrollTo({top: y, behavior: 'smooth'});
                    }}
                    to="/products/membranes/classic-line#terrazzo"
                  >
                    <button className="btnSecond">
                      Learn More
                      <span className="sr-only">detail about classic line</span>
                    </button>
                  </HashLink>
                </div>
              </div>
            </Grid>

            <Grid
              size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="featured-product-image-card">
                <img
                  srcSet={featuredImage}
                  src={featuredImage}
                  alt="Dec-Tec Terrazzo"
                  className="featured-product-image"
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default NewProduct;
